import { useEffect, useRef, useState } from "react";
import AdminNavBar from "./AdminNavBar";
import UnitsNavBar from "./UnitsNavBar";

const DeleteUnit = () => {
	interface Unit {
		id:number;
		unit: string;
		active: boolean;
	}

	var unitRef = useRef<HTMLSelectElement>(null)
	const [units, setUnits] = useState<Unit[]>([])
	const [isVisible, setIsVisible] = useState(false)
	const [selectedUnit, setSelectedUnit] = useState<Unit>({ id: 0, unit: "", active: false })
	const [msg, setMsg] = useState("")
	
	const getUnits = async () => {
		const response = await fetch(process.env.REACT_APP_API+"/api/units")
		const units = await response.json()
		setUnits(units)
	}
	
	const handleSelectChange = async () => {
		if (unitRef && unitRef.current) {
			const id = unitRef.current.value;
			const response = await fetch(process.env.REACT_APP_API+"/api/unit?id=" + id);
			const unit = await response.json()
			setSelectedUnit(unit)
			setIsVisible(true)
			setMsg("")
		} 
	}

	const deleteUnit = async () => {
		const payload = {"id": selectedUnit.id}
		const response = await fetch(process.env.REACT_APP_API+"/api/unitDelete", {
			method: "DELETE",
			body: JSON.stringify(payload)
		})
		setMsg(selectedUnit.unit + " deleted.")
		if (unitRef && unitRef.current) {
			unitRef.current.value=""
		}
		getUnits()
	}
	
	useEffect(() => {
		getUnits()
	}, [])
	return (
		<div className="resilire">
			<AdminNavBar />
			<UnitsNavBar />
			<label htmlFor="unit">Unit Name</label>
			<select id="units" onChange={handleSelectChange} ref={unitRef}>
				<option value=""></option>
				{units.map((unit) => (
					<option value={unit.id} key={unit.id}>{unit.unit}</option>
				))}
			</select>
			{
				isVisible && (
					<div className="resilire">
						<button name="submit" onClick={deleteUnit}>Delete</button>
					</div>
				)
			}
			{msg && (
				<div>
					{msg}
				</div>
			)}
		</div>
	)
};
export default DeleteUnit;
